import React from 'react';

const inputStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--space-xs)',
    width: '100%',
  },
  label: {
    fontFamily: 'var(--font-display)',
    fontSize: '0.85rem',
    fontWeight: 500,
    color: 'var(--color-text-secondary)',
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    backgroundColor: 'var(--color-bg-secondary)',
    border: '2px solid rgba(212, 175, 55, 0.15)',
    borderRadius: 'var(--radius-md)',
    color: 'var(--color-text-primary)',
    fontSize: '1rem',
    fontFamily: 'var(--font-body)',
    transition: 'all var(--transition-fast)',
    outline: 'none',
  },
  inputError: {
    borderColor: 'var(--color-danger)',
  },
  errorText: {
    fontSize: '0.8rem',
    color: 'var(--color-danger)',
    margin: 0,
  },
};

export default function Input({
  label,
  error,
  type = 'text',
  value,
  onChange,
  placeholder,
  name,
  id,
  required = false,
  disabled = false,
  style,
  ...props
}) {
  const inputId = id || name;

  return (
    <div style={inputStyles.wrapper}>
      {label && (
        <label htmlFor={inputId} style={inputStyles.label}>
          {label}
          {required && <span style={{ color: 'var(--color-danger)', marginLeft: '4px' }}>*</span>}
        </label>
      )}
      <input
        id={inputId}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        style={{
          ...inputStyles.input,
          ...(error ? inputStyles.inputError : {}),
          ...(disabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}),
          ...style,
        }}
        onFocus={(e) => {
          e.target.style.borderColor = error ? 'var(--color-danger)' : 'var(--color-primary)';
          e.target.style.boxShadow = error
            ? '0 0 0 3px rgba(231, 76, 60, 0.15)'
            : '0 0 0 3px rgba(212, 175, 55, 0.15)';
        }}
        onBlur={(e) => {
          e.target.style.borderColor = error
            ? 'var(--color-danger)'
            : 'rgba(212, 175, 55, 0.15)';
          e.target.style.boxShadow = 'none';
        }}
        {...props}
      />
      {error && <p style={inputStyles.errorText}>{error}</p>}
    </div>
  );
}
